// Plik: frontend/src/pages/HomePage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Button, Box, Paper, CircularProgress } from '@mui/material';
import { settingsService } from '../services/api';

const HomePage = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      const response = await settingsService.getSettings();
      if (response.success) {
        setSettings(response.data);
      }
      setLoading(false);
    };
    fetchSettings();
  }, []);

  if (loading) {
    return (
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom>
          {settings?.home_title || 'System Rejestracji na Wydarzenie'}
        </Typography>
        
        <Paper elevation={3} sx={{ p: 4, my: 3 }}>
          <Typography variant="body1" paragraph>
            {settings?.home_description || 'Witamy w systemie rejestracji na nasze wydarzenie! Zapraszamy do zapisów na wybrane terminy wizyt.'}
          </Typography>
          
          <Typography variant="body1" paragraph>
            {settings?.home_cta_text || 'Aby dokonać rejestracji, kliknij przycisk poniżej i wypełnij formularz.'}
          </Typography>
          
          <Box sx={{ mt: 4 }}>
            <Button 
              component={Link} 
              to="/rejestracja" 
              variant="contained" 
              size="large" 
              color="primary"
              sx={{ py: 1, px: 4 }}
            >
              {settings?.home_button_text || 'Przejdź do rejestracji'}
            </Button>
          </Box>
        </Paper>
        
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {settings?.home_footer_text || 'Masz pytania? Skontaktuj się z nami.'}
        </Typography>
      </Box>
    </Container>
  );
};

export default HomePage;